type Props = (value: string, keyword: string) => boolean;

const containsText: Props = (value, keyword) => {
  const contains = value.toLowerCase().trim().indexOf(keyword.toLowerCase().trim()) > -1;
  return contains;
};

export default containsText;
